import Vuex from 'vuex'
import VuexPersistedState from 'vuex-persistedstate'

export default new Vuex.Store({
    plugins: [
        VuexPersistedState({
            paths: [
                "token",
                "user",
                "locale",
                "showOnlyProductsWithRemainingQuantities"
            ]
        })
    ],
    state: {
        token: null,
        user: null,
        isAdmin: false,
        isSuperAdmin: false,
        locale: 'fr',
        showOnlyProductsWithRemainingQuantities: false,
        memberBuyGroup: null
    },
    getters: {
        isAdmin(state) {
            if (state.user === null) {
                return false
            }
            if (state.user.status === "super_admin") {
                return true;
            }
            const adminBuyGroup = state.user.BuyGroups.find((buyGroup) => {
                return buyGroup.MembersBuyGroups.isAdmin === true;
            })
            return adminBuyGroup !== undefined;
        },
        isSuperAdmin(state) {
            if (state.user === null) {
                return false
            }
            return ['super_admin'].includes(state.user.status)
        },
        buyGroupIdAdmin(state) {
            if (state.user === null) {
                return null
            }
            const adminBuyGroup = state.user.BuyGroups.find((buyGroup) => {
                return buyGroup.MembersBuyGroups.isAdmin === true;
            })
            if (!adminBuyGroup) {
                return null;
            }
            return adminBuyGroup.id;
        }
    },
    mutations: {
        setToken: function (state, token) {
            state.token = token
            if (!token) {
                state.user = null;
            }
        },
        setUser: function (state, user) {
            state.user = user;
            if (user === null) {
                state.memberBuyGroup = null;
            }
        },
        setLocale: function (state, locale) {
            if (state.locale === locale) {
                return
            }
            state.locale = locale;
            location.reload();
        },
        setShowOnlyProductsWithRemainingQuantities: function (state, showOnlyProductsWithRemainingQuantities) {
            state.showOnlyProductsWithRemainingQuantities = showOnlyProductsWithRemainingQuantities;
        },
        setMemberBuyGroup: function (state, memberBuyGroup) {
            state.memberBuyGroup = memberBuyGroup;
        },
    },
    actions: {
        setToken: function (action, token) {
            action.commit('setToken', token)
        },
        setUser: function (action, user) {
            action.commit('setUser', user)
        },
        setLocale: function (action, locale) {
            action.commit('setLocale', locale)
        },
        setShowOnlyProductsWithRemainingQuantities: function (action, showOnlyProductsWithRemainingQuantities) {
            action.commit('setShowOnlyProductsWithRemainingQuantities', showOnlyProductsWithRemainingQuantities)
        },
        setMemberBuyGroup: function (action, memberBuyGroup) {
            action.commit('setMemberBuyGroup', memberBuyGroup)
        },
    },
    modules: {}
})
